import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ControlService } from '../admin/control.service';

export const controlParamsResolver: ResolveFn<boolean> = (route, state) => {
  return inject(ControlService).getControlWithImages();
};

